import InsuranceLayout from "./components/admin/InsuranceLayout";
import InsuranceRoute from "./router/InsuranceRoute";
import ProtectedRoute from './utils/ProtectedRoute';
import FrontendRoute from './router/FrontendRoute';
import Toaster from "./components/common/Toaster";
import Layout from './components/frontend/Layout';
import { Route, Routes } from "react-router-dom";
import NotFound from "./pages/frontend/NotFound";
import Loader from "./components/common/Loader";
import { Suspense } from "react";
import './i18n';

function App() {
  return (
    <div className="App">
      <Toaster />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            {FrontendRoute &&
              FrontendRoute.map((item, index) => (
                <Route key={index} path={item.path} element={item.component} />
              ))
            }
          </Route>
          <Route path="/insurance" element={<InsuranceLayout />}>
            {InsuranceRoute &&
              InsuranceRoute.map((item, index) => (
                <Route key={index} path={item.path} element={<ProtectedRoute>{item.component}</ProtectedRoute>} />
              ))
            }
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
